import { useState } from 'react';
import { Settings, Globe, Bell, Shield, Save, CheckCircle } from 'lucide-react';
import { useI18n, LanguageToggle } from '../i18n';

export function SettingsPage() {
    const { t } = useI18n();
    const [saved, setSaved] = useState(false);

    const [notifications, setNotifications] = useState({
        newAppointment: true,
        cancelledAppointment: true,
        patientArrived: true,
        labResults: true,
        lowNpsScore: true,
    });

    function handleSave() {
        setSaved(true);
        setTimeout(() => setSaved(false), 2000);
    }

    return (
        <div className="fade-in">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <h1 className="page-title"><Settings size={22} style={{ display: 'inline', marginRight: 8 }} />{t('nav.settings')}</h1>
                <button className="btn btn-primary" onClick={handleSave} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    {saved ? <><CheckCircle size={16} /> Guardado</> : <><Save size={16} /> Guardar</>}
                </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                {/* Language */}
                <div className="card" style={{ padding: 20 }}>
                    <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Globe size={18} /> Idioma / Language
                    </h2>
                    <LanguageToggle />
                </div>

                {/* Notifications */}
                <div className="card" style={{ padding: 20 }}>
                    <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Bell size={18} /> Notificaciones del coordinador
                    </h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {[
                            { key: 'newAppointment' as const, label: 'Nueva cita agendada', desc: 'Notificación cuando un paciente agenda una cita' },
                            { key: 'cancelledAppointment' as const, label: 'Cita cancelada', desc: 'Notificación de cancelaciones de citas' },
                            { key: 'patientArrived' as const, label: 'Paciente llegó', desc: 'Notificación cuando un paciente llega a la clínica' },
                            { key: 'labResults' as const, label: 'Resultados de laboratorio', desc: 'Notificación de resultados de laboratorio recibidos' },
                            { key: 'lowNpsScore' as const, label: 'NPS bajo (≤6)', desc: 'Alerta para puntajes NPS detractores que requieren seguimiento' },
                        ].map(item => (
                            <div key={item.key} style={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                padding: '12px 16px', borderRadius: 8, background: 'var(--bg-2, #f8f9fa)',
                            }}>
                                <div>
                                    <div style={{ fontWeight: 500, fontSize: 14 }}>{item.label}</div>
                                    <div style={{ fontSize: 12, color: 'var(--text-3, #999)', marginTop: 2 }}>{item.desc}</div>
                                </div>
                                <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: 'pointer' }}>
                                    <input type="checkbox" checked={notifications[item.key]}
                                        onChange={e => setNotifications(n => ({ ...n, [item.key]: e.target.checked }))}
                                        style={{ opacity: 0, width: 0, height: 0 }}
                                    />
                                    <span style={{
                                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                                        background: notifications[item.key] ? 'var(--accent, #0D7C7C)' : '#ccc',
                                        borderRadius: 12, transition: 'background 0.2s',
                                    }}>
                                        <span style={{
                                            position: 'absolute', top: 2, left: notifications[item.key] ? 22 : 2,
                                            width: 20, height: 20, borderRadius: '50%', background: 'white',
                                            transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                        }} />
                                    </span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Security */}
                <div className="card" style={{ padding: 20 }}>
                    <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Shield size={18} /> Seguridad
                    </h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderRadius: 8, background: 'var(--bg-2, #f8f9fa)' }}>
                        <div>
                            <div style={{ fontWeight: 500, fontSize: 14 }}>Administrar cuenta</div>
                            <div style={{ fontSize: 12, color: 'var(--text-3, #999)', marginTop: 2 }}>Cambiar contraseña, sesiones activas — gestionado por Keycloak</div>
                        </div>
                        <a href="http://localhost:8180/realms/clinicos/account" target="_blank" rel="noopener noreferrer"
                            className="btn btn-secondary" style={{ fontSize: 13 }}>
                            Abrir Keycloak
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
